function cleanTitle(service) {
  return (service.card_title || service.name || "")
    .replace(/^Configurador:\s*/i, "")
    .trim();
}

function subtitle(service) {
  if (service.card_subtitle) return service.card_subtitle;
  const slug = service.slug || "";
  if (slug.includes("documentos") || slug.includes("impresion")) return "PDFs, apuntes, trabajos y documentos";
  if (slug.includes("fotos")) return "Fotos, copias y ampliaciones";
  if (slug.includes("carteles")) return "Carteles, pósters y láminas";
  if (slug.includes("planos")) return "Planos y gran formato";
  if (slug.includes("pegatinas")) return "Pegatinas y adhesivos";
  if (slug.includes("tfg")) return "TFG, tesis y encuadernaciones";
  return service.description || "Configura tu pedido fácilmente";
}

function presetSummary(service) {
  const cfg = service.default_configuration || {};
  const parts = [];

  if (cfg.size) parts.push(cfg.size);
  if (cfg.color === "bw") parts.push("B/N");
  if (cfg.color === "color") parts.push("Color");
  if (cfg.sides === "double") parts.push("Doble cara");
  if (cfg.sides === "single") parts.push("Una cara");

  const paperLabels = {
    "papel-80g": "Papel 80 g",
    "papel-brillo-150g": "Brillo 150 g",
    "papel-fotografico-premium-brillo": "Papel fotográfico",
    "cartulina-brillo-350g": "Brillo 350 g",
  };

  if (cfg.paper) parts.push(paperLabels[cfg.paper] || cfg.paper);

  return parts.slice(0, 4).join(" · ");
}

export default function ServiceSelector({ services = [], selectedSlug, onSelect }) {
  if (!services.length) return null;

  return (
    <section className="mb-5">
      <div className="mb-4 text-center">
        <h2 className="text-2xl font-black text-slate-900">¿Qué necesitas hoy?</h2>
        <p className="mt-1 text-sm font-semibold text-slate-500">
          Elige el tipo de trabajo y KAPEI te mostrará solo lo necesario.
        </p>
      </div>

      <div className="grid gap-4">
        {services.map((service) => {
          const slug = service.slug || service.id;
          const selected = selectedSlug === slug;
          const title = cleanTitle(service);
          const color = service.card_color || "#4d7c0f";
          const summary = presetSummary(service);

          return (
            <button
              key={slug}
              type="button"
              onClick={() => onSelect(service)}
              data-testid={`service-card-${slug}`}
              className={`group overflow-hidden rounded-[2rem] border-2 bg-white text-left shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl ${
                selected ? "border-[#4d7c0f] ring-4 ring-[#4d7c0f]/10" : "border-slate-200"
              }`}
            >
              <div className="relative min-h-[210px]">
                <div className="absolute inset-x-0 top-0 h-28 bg-slate-50">
                  {service.card_image ? (
                    <img
                      src={service.card_image}
                      alt={title}
                      className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                      onError={(e) => {
                        e.currentTarget.style.display = "none";
                      }}
                    />
                  ) : (
                    <div
                      className="flex h-full w-full items-center justify-center text-6xl"
                      style={{ backgroundColor: `${color}12`, color }}
                    >
                      {service.icon || "📦"}
                    </div>
                  )}
                </div>

                <div className="relative flex min-h-[210px] flex-col justify-end p-5 pt-32">
                  <div className="text-xs font-black uppercase tracking-widest" style={{ color }}>
                    {service.card_featured ? "Recomendado" : "KAPEI"}
                  </div>

                  <div className="mt-1 text-2xl font-black leading-tight text-slate-900">
                    {title}
                  </div>

                  <div className="mt-1 text-sm font-semibold text-slate-500">
                    {subtitle(service)}
                  </div>

                  {summary && (
                    <div className="mt-3 rounded-full px-3 py-2 text-xs font-black" style={{ backgroundColor: `${color}12`, color }}>
                      {summary}
                    </div>
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </section>
  );
}
